import { CHAT_HISTORY_LIST_TAG, LIST_QUERY_CACHE_TTL_SECONDS } from '@/api/constants';
import { api } from '@/api/core';
import type { ChatHistoryData } from '@/api/chat/getChatHistory';
import { queryMockRecentProjectChats } from './mockProjectChats';
import { mockDelay } from './mockUtils';

export interface GetRecentProjectChatsRequest {
  projectId: string;
  limit?: number;
}

export interface GetRecentProjectChatsResponse {
  /** Most recent activity first. */
  chats: ChatHistoryData[];
}

const MOCK_RESPONSE_DELAY_MS = 300;

const getRecentProjectChatsApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getRecentProjectChats: builder.query<GetRecentProjectChatsResponse, GetRecentProjectChatsRequest>({
      // The backend endpoint for a project's chats does not exist yet: serve mock data (see mockProjectChats.ts).
      queryFn: async (args) => {
        await mockDelay(MOCK_RESPONSE_DELAY_MS);
        const response = queryMockRecentProjectChats(args);

        return response ? { data: response } : { error: { status: 404, data: 'Project not found' } };
      },
      // Refetched when a chat is deleted.
      providesTags: () => [{ type: CHAT_HISTORY_LIST_TAG }],
      keepUnusedDataFor: LIST_QUERY_CACHE_TTL_SECONDS,
    }),
  }),
});

export const { useGetRecentProjectChatsQuery } = getRecentProjectChatsApi;
